import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { connect } from "scrivito"
import { ProductInformation } from "shared/types/__generated__/graphql"

import { ProductConfigurationAttributes } from "entities/products/ui/product-configuration-attributes/ProductConfigurationAttributes"

type ProductPageAttributesProps = Omit<
  React.ComponentPropsWithoutRef<"section">,
  "ref"
> & {
  productInformation: ProductInformation | null | undefined
  isLoading?: boolean
}

function ProductPageAttributesComponent({
  productInformation,
  isLoading,
  className,
  ...rest
}: ProductPageAttributesProps) {
  const { t } = useTranslation()

  if (!productInformation?.attributes && !isLoading) {
    return null
  }

  return (
    <ProductConfigurationAttributes.Root
      productInformation={productInformation}
      isLoading={isLoading}
    >
      <section
        {...rest}
        className={classNames(
          "product-page__attributes product-page__section product-configuration-attributes card card--elevated",
          className
        )}
      >
        <div className="product-page__section-header">
          <h3 className="product-page__section-title">
            {t("Product.Information.ConfigurationAttributes")}
          </h3>
          <ProductConfigurationAttributes.CopyToClipboard />
        </div>

        <ProductConfigurationAttributes.Content />

        <div className="product-page__section-footer">
          <ProductConfigurationAttributes.CopyToClipboard />
        </div>
      </section>
    </ProductConfigurationAttributes.Root>
  )
}

export const ProductPageAttributes = React.memo(
  connect(ProductPageAttributesComponent)
)
